import {
  IMPORT_CLIENTS_IN_PROGRESS,
  IMPORT_CLIENTS_SUCCESS,
  IMPORT_CLIENTS_FAIL,
} from "../constants";

const initialState = {
  error: undefined,
  success: null,
  tsvReport: null,
};

/**
 * Import clients reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function importClients(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case IMPORT_CLIENTS_IN_PROGRESS:
      return {
        ...initialState,
      };

    case IMPORT_CLIENTS_SUCCESS:
      return {
        ...state,
        success: true,
        error: null,
        tsvReport: payload.tsvReport,
      };

    case IMPORT_CLIENTS_FAIL:
      return {
        ...state,
        success: false,
        error: payload.error,
      };

    default:
      return state;
  }
}
